import { Box, Typography } from "@mui/material";
import MediaGallery from "../../documents-tab/media-gallery";
import { TrackDocument } from "@/modules/property-tracks/types";

export default function ListingMedia({
  documents,
  title,
}: {
  documents: TrackDocument[];
  title: string;
}) {
  return (
    <Box
      sx={(theme) => ({
        width: "50%",
        p: 2,
        borderRadius: theme.nawy.radius.xl,
        backgroundColor: theme.nawy.colors.primitives.white[100],
      })}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1,
        }}
      >
        <Typography
          sx={(t) => t.nawy.typography.english.variants.body.md.semibold}
        >
          {title}
        </Typography>
      </Box>

      <MediaGallery data={documents.map((d) => d.fileUrl)} isLoading={false} />
    </Box>
  );
}
